// extracted by mini-css-extract-plugin
export default {"slide":"slide__slide__7YDsc","title":"slide__title__HwxiZ"};